import { default as good_status } from "../../../AE2/static/icons/customer_page/Building Performance Overview/Good.svg"
import { default as monitor_status } from "../../../AE2/static/icons/customer_page/Building Performance Overview/Monitor.svg"
import { default as attention_status } from "../../../AE2/static/icons/customer_page/Building Performance Overview/Needs Attention.svg"
import { default as utility_bills_icon } from "../../../AE2/static/icons/customer_page/Recent Activity/Utility Bills Processed.svg"
import { default as savings_report_icon } from "../../../AE2/static/icons/customer_page/Recent Activity/Savings Report.svg"
import { default as energy_star_icon } from "../../../AE2/static/icons/customer_page/Recent Activity/Energy Star Score.svg"
import { default as annual_report_icon } from "../../../AE2/static/icons/customer_page/Recent Activity/Annual Report.svg"
import { default as incentive_icon } from "../../../AE2/static/icons/kpi_summary/Incentives.svg"
import { default as report_dark_blue } from "../../../AE2/static/icons/customer_page/Recent Activity/Extra Report - Dark Blue.svg"
import { default as report_light_blue } from "../../../AE2/static/icons/customer_page/Recent Activity/Extra Report - Light Blue.svg"

export type BuildingStatus = 'Good' | 'Monitor' | 'Needs Attention'

export const STATUS_ICONS: Record<BuildingStatus, string> = {
    'Good': good_status,
    'Monitor': monitor_status,
    'Needs Attention': attention_status,
}

export interface DashboardBuilding {
    uuid: string
    building_name: string
    type: string
    savings: number | null
    score: number | null
    status: BuildingStatus
}

export interface DashboardSummary {
    verifiedSavings: { total_savings: number, deltaThisMonth: number, latest_date: string | null }
    incentives: { total: number }
    buildingsTracked: { value: number }
    totalSqFt: number
    ghgReduction: { total: number, percent_reduction: number, deltaThisMonth: number }
    solarPanels: { total: number, deltaThisMonth: number }
}

export interface ActivityItem {
    id: string
    type: string
    title: string
    detail: string
    date: string
}

export interface EnvironmentalImpact {
    co2_tons: number
    trees: number
    homes: number
    cars: number
}

export interface CustomerDashboardData {
    summary: DashboardSummary
    buildings: DashboardBuilding[]
    recentActivity: ActivityItem[]
    environmentalImpact: EnvironmentalImpact
}

export const ACTIVITY_ICONS: Record<string, string> = {
    benchmark_completed: annual_report_icon,
    score_declined: energy_star_icon,
    score_updated: energy_star_icon,
    incentive_received: incentive_icon,
    target_met: savings_report_icon,
    target_not_met: savings_report_icon,
    building_updated: utility_bills_icon,
}

export interface ReportItem {
    id: string
    icon: string
    title: string
    url?: string
}

// TODO: reports have no customer-scoped listing endpoint yet, so these are static placeholders.
export const REPORTS: ReportItem[] = [
    { id: 'savings', icon: report_light_blue, title: 'Savings Report' },
    { id: 'annual', icon: report_light_blue, title: 'Annual Performance Report' },
    { id: 'benchmark', icon: report_light_blue, title: 'Benchmark Report' },
    { id: 'story_pdf', icon: report_light_blue, title: 'Success Story PDF' },
    { id: 'story_ppt', icon: report_dark_blue, title: 'Success Story PowerPoint Slide' },
]
